var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alerts--box"},_vm._l((_vm.alerts),function(alert){return _c('a-template',{key:alert.id,staticClass:"alerts--base set-flex",class:alert.type ? ("alerts--" + (alert.type) + " ") : '',attrs:{"alert":alert}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }